import clsx from 'clsx'
import React, { useState } from 'react'
import { TextEditor } from '../TextEditor'
// import SendAlertTo from '../Select/SendAlert'
import CustomAlert from '../CustomAlert'
import SelectBoard from '../Select/SelectBoard'
import SelectStatus from '../Select/SelectStatus'
import Skeleton from 'react-loading-skeleton'
import AssignTo from '../Select/AssignTo'
import SelectTags from '../Select/SelectTags'
import { capitalizeEachWord, removeDuplication } from '../../helper-functions/CapitalizeName'
import { formatDateAndTime } from '../../helper-functions/TimeFormate'
import { FileUploadPage } from '../FileUploader/FileUpload'
import { useInputScrollToStart } from '../../hooks'
import SendEnvelopeModal from '../Modals/SendEnvelopeModal'
import FileIcon from '../GetUploadedFileIcons'
import { Dropdown, Spinner } from 'react-bootstrap'
import { downloadEnvelope, resendEnvelope, voidEnvelope } from '../../services/envelopes'
import VoidEnvelopeModal from '../Modals/VoidEnvelopeModal'
import ResendEnvelopeModal from '../Modals/ResendEnvelopeModal'
import ViewEnvelopeRecepient from '../Modals/ViewEnvelopeRecepient'
import ViewEnvelopeModal from '../Modals/ViewEnvelopeModal'
import { useAuth } from '../../modules/auth'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { copyToClipboard } from '../../utils/clipboard'

const EditPageForm: React.FC<any> = ({ theme, formik, editor, setEditor, updatedDate, boardId, setBoardId, allBoards, loading, tags, setSelectedTags, selectedTags, boardPerson, optionsForSendAlert, isUserAssignLoading, selected, setSelected, options, selectedOption, setSelectedOption, loadingDesc, transformedTags, deleteFileHandler, selectedFile,
    // setSendAlertMsg, sendAlertMsg,sendAlertTo, setSendAlertTo,
    changeHandler, setOpenInviteModal,
    socialMediaContent, setsocialMediaContent, otherLinksContent, setOtherLinksContent,
    fileErrorMsg,
    setFileErrorMsg, editorTags, setEditorTags, tocHeading, setTocHeading, imageErrorMsg, setImageErrorMsg,
    setSocialMediaMentions, setNotesMentions, setOtherLinksMentions, retainNotesMentions, retainSocialLinksMentions, retainOtherLinksMentions, uniqueId, pageId, envelopes,
    getPageHandler, pageloading, currentPage, isExpandedModal,
    expandedField, setExpandedField, boardName
}) => {

    const formattedDate = formatDateAndTime(updatedDate)
    const [activeTab, setActiveTab] = useState<string>('notes');

    const [showTooltip, setShowTooltip] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);
    const titleInputRef = useInputScrollToStart<HTMLInputElement>();
    const [showEnvelopeModal, setShowEnvelopeModal] = useState(false);

    const [isLoading, setIsLoading] = useState<any>(null)
    const [isDownloading, setIsDownloading] = useState<any>(null)
    const [showVoidModal, setShowVoidModal] = useState<boolean>(false)
    const [showResendModal, setShowResendModal] = useState<boolean>(false)
    const [selectedEnvelope, setSelectedEnvelope] = useState<any>(null)
    const [successMessage, setSuccessMessage] = useState<string>('')
    const [errorMessage, setErrorMessage] = useState<string>('')
    const [openViewEnvelope, setOpenViewEnvelope] = useState(false)
    const [openViewRecepeints, setOpenViewRecepeints] = useState(false)
    const { integrations } = useSelector((state: any) => state.integrationReducer)
    const isIntegrationAvailable = integrations?.map((integration: any) => integration?.name.toLowerCase()).includes('docusign') || false;
    const hasAccess = integrations?.find((integration: any) => integration?.name.toLowerCase() === 'docusign')?.hasAccess || false;
    const { currentUser } = useAuth();
    const id = currentUser?.data?.user?.id;
    const navigate = useNavigate();
    const resendEnvelopeHandler = async () => {
        setIsLoading(true)
        try {
            const res = await resendEnvelope(selectedEnvelope?.envelopeId)
            if (res.data.success) setSuccessMessage(res.data.message)
            setTimeout(() => {
                setShowResendModal(false)
            }, 3000);
        } catch (error: any) {
            // eslint-disable-next-line
            setErrorMessage(error?.response?.data?.message)
        } finally {
            setTimeout(() => {
                setIsLoading(false)
                setSelectedEnvelope(null)
                setErrorMessage('')
                setSuccessMessage('')
            }, 3000);
        }
    }
    const voidEnvelopeHandler = async (reason: string) => {
        setIsLoading(true)
        try {
            const payload = { reason }
            const res = await voidEnvelope(selectedEnvelope?.envelopeId, payload)
            if (res.data.success) {
                //     if(setData){ setData((prev: any) => ({
                //         ...prev,
                //         envelopes: prev?.envelopes?.map((item: any) =>
                //             item.envelopeId === selectedEnvelope?.envelopeId
                //                 ? { ...item, status: 'voided' }
                //                 : item
                //         ),
                //     }));
                // }
                setSuccessMessage(res.data.message)
            }
            setTimeout(() => {
                setShowVoidModal(false)
            }, 3000);
        } catch (error: any) {
            // eslint-disable-next-line
            setErrorMessage(error?.response?.data?.message)
        } finally {
            setTimeout(() => {
                setIsLoading(false)
                setSelectedEnvelope(null)
                setErrorMessage('')
                setSuccessMessage('')
            }, 3000);
        }
    }
    const downloadEnvelopeHandler = async (envelope: any) => {
        setIsDownloading(envelope?.envelopeId)
        try {
            const response: any = await downloadEnvelope(envelope?.envelopeId)
            const blob = new Blob([response.data]);
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition?.match(/filename="?(.+?)"?$/i)?.[1]
                || `${envelope?.documentName || 'document'}.pdf`;

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 100);

        } catch (error) {
            // eslint-disable-next-line
            console.error('Download failed:', error);
        } finally {
            setIsDownloading(null)
        }
    }

    const handleOpenWebApp = () => {
        const webAppUrl = formik.values.webAppName;
        if (webAppUrl) {
            // Add protocol if not present
            const url = webAppUrl.startsWith('http://') || webAppUrl.startsWith('https://')
                ? webAppUrl
                : `https://${webAppUrl}`;
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    const handleCopyWebApp = async () => {
        const webAppUrl = formik.values.webAppName;
        if (webAppUrl) {
            const ok = await copyToClipboard(webAppUrl);
            if (ok) {
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            }
        }
    };

    const inputStyle = {
        backgroundColor: theme === 'dark' ? '#2C3A4D' : '#ffffff',
        color: theme === 'dark' ? '#F4FFFD' : '#17181f',
        border: `1px solid ${theme === 'dark' ? 'hsl(0, 0%, 80%)' : '#ccc'}`,
        borderRadius: '4px',
        padding: '8px 12px',
        boxShadow: `0 0 0 1px ${theme === 'dark' ? '#333' : '#ccc'}`,
        outline: 'none',
        margin: '2px'
    }

    const closeEnvelopeModal = () => {
        setShowEnvelopeModal(false);
    };

    return (
        <form className='form row' onSubmit={formik.handleSubmit} noValidate>
            {/* Title row — hidden when a field is expanded */}
            {!expandedField && (
                <div className='col-12 mb-2 pe-0'>
                    <label
                        className={`form-label fs-6 fw-bolder ${theme === 'dark' ? 'white__text' : 'text-dark'
                            } `}
                    >
                        Title
                    </label>
                    <input
                        ref={titleInputRef}
                        autoFocus
                        {...formik.getFieldProps('title')}
                        disabled={boardPerson?.role === 'Guest'}
                        className={clsx(
                            `form-control form-control-solid ${theme === 'dark' ? 'dark__theme__input' : ''}`,
                            { 'is-invalid': formik.touched.title && formik.errors.title },
                            {
                                'is-valid': formik.touched.title && !formik.errors.title,
                            }
                        )}
                        type='name'
                        name='title'
                        autoComplete='off'
                        maxLength={300}
                        placeholder=''
                        tabIndex={1}
                    />
                    {formik.touched.title && formik.errors.title && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert' className='text-danger'>
                                {formik.errors.title}
                            </span>
                        </div>
                    )}
                </div>
            )}
            <div className={expandedField ? 'col-12' : 'col-md-12 col-lg-8 col-sm-12'}>
                {!expandedField && (<div className='row mb-5'>

                    <div className='col-md-12 col-lg-12 col-sm-12'>
                        <label
                            className={`form-label fs-6 fw-bolder ${theme === 'dark' ? 'white__text' : 'text-dark'
                                } `}
                        >
                            Source
                        </label>
                        <div className='d-flex align-items-center gap-2'>
                            <input
                                {...formik.getFieldProps('webAppName')}
                                disabled={boardPerson?.role === 'Guest'}
                                className={clsx(
                                    `form-control form-control-solid ${theme === 'dark' ? 'dark__theme__input' : ''}`,
                                    { 'is-invalid': formik.touched.webAppName && formik.errors.webAppName },
                                    {
                                        'is-valid': formik.touched.webAppName && !formik.errors.webAppName,
                                    }
                                )}
                                type='name'
                                name='webAppName'
                                autoComplete='off'
                                maxLength={300}
                                placeholder='e.g. acme.com or Notion'
                                tabIndex={2}
                            />
                            <i
                                className={`bi bi-box-arrow-in-up-right fs-1 cursor-pointer ${theme === 'dark' ? 'text-white' : 'text-dark'} ${!formik.values.webAppName ? 'opacity-50' : ''}`}
                                onClick={handleOpenWebApp}
                                title='Open in new tab'
                                style={{
                                    cursor: formik.values.webAppName ? 'pointer' : 'not-allowed',
                                    minWidth: '24px'
                                }}
                            ></i>
                            <i
                                className={`bi ${copySuccess ? 'bi-check2' : 'bi-copy'} fs-1 cursor-pointer ${theme === 'dark' ? 'text-white' : 'text-dark'} ${!formik.values.webAppName ? 'opacity-50' : ''} ${copySuccess ? 'text-success' : ''}`}
                                onClick={handleCopyWebApp}
                                title={copySuccess ? 'Copied!' : 'Copy'}
                                style={{
                                    cursor: formik.values.webAppName ? 'pointer' : 'not-allowed',
                                    minWidth: '24px'
                                }}
                            ></i>
                        </div>
                        {formik.touched.webAppName && formik.errors.webAppName && (
                            <div className='fv-plugins-message-container'>
                                <span role='alert' className='text-danger'>
                                    {formik.errors.webAppName}
                                </span>
                            </div>
                        )}
                    </div>
                </div>)}
                {/* Tab header row — always visible (even in expanded view) */}
                <div className={`d-flex gap-3 ${expandedField ? 'align-items-center justify-content-between' : ''}`}>
                    <div className='d-flex gap-3 flex-wrap'>
                        <div className='d-flex align-items-center gap-2'>
                            <h6
                                className={`my-3 cursor-pointer  ${theme === 'dark' ? ` ${activeTab === 'notes' ? 'text-white' : 'active_tab'}` : `${activeTab === 'notes' ? '' : 'active_tab'}`}
                           `}
                                onClick={() => { setActiveTab('notes'); if (expandedField && expandedField !== 'notes') setExpandedField('notes') }}
                            >
                                Notes
                            </h6>
                            <div
                                className="tooltip-container cursor-pointer"
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                            >
                                <i className={`bi bi-list bg-transparent fs-3 ${theme === 'dark' ? 'theme__div' : ''}`}></i>
                                {showTooltip && editorTags?.length > 0 && <span className="tooltiptext">
                                    <div className='head fs-2 fw-bolder px-2 mb-2'>Contents of this page</div>
                                    {editorTags?.map((tag: any) => (
                                        tag?.name?.length > 0 && (
                                            <div
                                                key={tag.name}
                                                onClick={() => {
                                                    setTocHeading(tag);
                                                    setShowTooltip(false);
                                                }}
                                            >
                                                <div className={`${tag?.tagName === 'h1' ? 'fs-4' : 'fs-4 ms-8'} cursor-pointer my-3 headings`}>
                                                    {tag.name}
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </span>}
                            </div>
                        </div>
                        <h6
                            className={`my-3 cursor-pointer d-flex align-items-center gap-1 ${theme === 'dark' ? ` ${activeTab === 'socialMedia' ? 'text-white' : 'active_tab'}` : `${activeTab === 'socialMedia' ? '' : 'active_tab'}`}`}
                            onClick={() => { setActiveTab('socialMedia'); if (expandedField && expandedField !== 'socialMedia') setExpandedField('socialMedia') }}
                        >
                            Social media links
                            {(() => {
                                if (!socialMediaContent) return null;
                                const cleaned = socialMediaContent?.replace(/\s+/g, "");
                                const withoutEmptyParas = cleaned.replace(/(<p><br><\/p>)+/g, "");
                                if (withoutEmptyParas === "") return null;
                                return <i className="bi bi-circle-fill text-danger" style={{ fontSize: "0.5rem" }}></i>;
                            })()}
                        </h6>
                        <h6
                            className={`my-3 cursor-pointer d-flex align-items-center gap-1 ${theme === 'dark' ? ` ${activeTab === 'otherLinks' ? 'text-white' : 'active_tab'}` : `${activeTab === 'otherLinks' ? '' : 'active_tab'}`}`}
                            onClick={() => { setActiveTab('otherLinks'); if (expandedField && expandedField !== 'otherLinks') setExpandedField('otherLinks') }}
                        >
                            Other links
                            {(() => {
                                if (!otherLinksContent) return null;
                                const cleaned = otherLinksContent?.replace(/\s+/g, "");
                                const withoutEmptyParas = cleaned.replace(/(<p><br><\/p>)+/g, "");
                                if (withoutEmptyParas === "") return null;
                                return <i className="bi bi-circle-fill text-danger" style={{ fontSize: "0.5rem" }}></i>;
                            })()}
                        </h6>
                    </div>
                </div>

                {/* Expanded field view */}
                {expandedField && !loadingDesc && !isUserAssignLoading && (
                    <div className='expanded-field-view'>
                        <div className='field-expandable notes-field' style={{ position: 'relative' }}>
                            <button
                                type='button'
                                className={`field-expand-btn is-close-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                                style={{ opacity: 1 }}
                                onClick={() => setExpandedField(null)}
                                title='Close expanded view'
                            >
                                <i className='bi bi-x-lg' style={{ fontSize: '1rem', color: theme === 'dark' ? '#ffffff' : '#212529' }}></i>
                            </button>
                            {expandedField === 'notes' && (
                                <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} setEditorTags={setEditorTags} role={boardPerson?.role} placeholder={''} setEditor={setEditor} editor={editor} tocHeading={tocHeading} optionsForSendAlert={optionsForSendAlert} setMentions={setNotesMentions} retainMentions={retainNotesMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                            )}
                            {expandedField === 'socialMedia' && (
                                <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} role={boardPerson?.role} placeholder={''} setEditor={setsocialMediaContent} editor={socialMediaContent} optionsForSendAlert={optionsForSendAlert} setMentions={setSocialMediaMentions} retainMentions={retainSocialLinksMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                            )}
                            {expandedField === 'otherLinks' && (
                                <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} role={boardPerson?.role} placeholder={''} setEditor={setOtherLinksContent} editor={otherLinksContent} optionsForSendAlert={optionsForSendAlert} setMentions={setOtherLinksMentions} retainMentions={retainOtherLinksMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                            )}
                        </div>
                    </div>
                )}

                {/* Normal (non-expanded) editor */}
                {!expandedField && (
                    (loadingDesc || isUserAssignLoading) ?
                        <React.Fragment>
                            <Skeleton count={1} height={35} />
                            <Skeleton count={1} height={155} />
                        </React.Fragment> :
                        <>
                            {activeTab === 'notes' && (
                                <div
                                    className='field-expandable notes-field'
                                    style={{ position: 'relative' }}
                                >
                                    {setExpandedField && (
                                        <button
                                            type='button'
                                            className={`field-expand-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                                            onClick={() => { setExpandedField('notes') }}
                                            title='Expand field'
                                        >
                                            <i className='bi bi-arrows-fullscreen' style={{ fontSize: '1rem' }}></i>
                                        </button>
                                    )}
                                    <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} setEditorTags={setEditorTags} role={boardPerson?.role} placeholder={''} setEditor={setEditor} editor={editor} tocHeading={tocHeading} optionsForSendAlert={optionsForSendAlert} setMentions={setNotesMentions} retainMentions={retainNotesMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                                </div>
                            )}
                            {activeTab === 'socialMedia' && (
                                <div
                                    className='field-expandable notes-field'
                                    style={{ position: 'relative' }}
                                >
                                    {setExpandedField && (
                                        <button
                                            type='button'
                                            className={`field-expand-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                                            onClick={() => { setExpandedField('socialMedia') }}
                                            title='Expand field'
                                        >
                                            <i className='bi bi-arrows-fullscreen' style={{ fontSize: '1rem' }}></i>
                                        </button>
                                    )}
                                    <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} role={boardPerson?.role} placeholder={''} setEditor={setsocialMediaContent} editor={socialMediaContent} optionsForSendAlert={optionsForSendAlert} setMentions={setSocialMediaMentions} retainMentions={retainSocialLinksMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                                </div>
                            )}
                            {activeTab === 'otherLinks' && (
                                <div
                                    className='field-expandable notes-field'
                                    style={{ position: 'relative' }}
                                >
                                    {setExpandedField && (
                                        <button
                                            type='button'
                                            className={`field-expand-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                                            onClick={() => { setExpandedField('otherLinks') }}
                                            title='Expand field'
                                        >
                                            <i className='bi bi-arrows-fullscreen' style={{ fontSize: '1rem' }}></i>
                                        </button>
                                    )}
                                    <TextEditor tabIndex={3} handleFormSubmission={formik.handleSubmit} boardId={boardId} role={boardPerson?.role} placeholder={''} setEditor={setOtherLinksContent} editor={otherLinksContent} optionsForSendAlert={optionsForSendAlert} setMentions={setOtherLinksMentions} retainMentions={retainOtherLinksMentions} uniqueId={uniqueId} currentCardOrPage={currentPage} isExpandedModal={isExpandedModal} enableChecklist />
                                </div>
                            )}
                        </>
                )}
                <CustomAlert
                    variant={'warning'}
                    className={'mt-2 w-100'}
                    alertMessage={imageErrorMsg}
                    setAlertMessage={setImageErrorMsg}
                />

                {!expandedField && <div className='row my-2'>
                    <div className='col-md-12'>
                        <FileUploadPage
                            deleteFileHandler={deleteFileHandler}
                            selectedFile={selectedFile}
                            changeHandler={changeHandler}
                        />
                        <CustomAlert
                            variant={'warning'}
                            className={'mt-2 w-75'}
                            alertMessage={fileErrorMsg}
                            setAlertMessage={setFileErrorMsg}
                            time={5000}
                        />
                    </div>

                </div>}
                {/* Show DocuSign section only when integration is available OR envelopes exist */}
                {!expandedField && ((isIntegrationAvailable && hasAccess) || (envelopes && envelopes.length > 0)) && (
                    <>
                        <hr />
                        <div className='row mt-3 mb-5 me-1 border'>
                            <div className='col-md-12'>
                                <div className={`card ${theme === 'dark' ? 'theme__div' : 'bg-white'}`}>
                                    <div className='card-header border-0  px-0'>
                                        <h3 className={`card-title align-items-start flex-column ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>
                                            <span className={`card-label fw-bold fs-3 ${theme === 'dark' ? 'text-white' : ''}`}>DocuSign Envelope</span>
                                        </h3>
                                        {envelopes && envelopes?.length > 0 && (
                                            <div className='card-toolbar gap-2'>
                                                {(isIntegrationAvailable && hasAccess) ?
                                                    <>
                                                        <button
                                                            type='button'
                                                            className='btn btn-icon btn-light btn-sm'
                                                            onClick={() => {
                                                                getPageHandler(pageId)
                                                            }}
                                                            title="Reload Envelopes"
                                                        >
                                                            <i className="bi bi-arrow-clockwise fs-4"></i>
                                                        </button>
                                                        <button
                                                            type='button'
                                                            className='btn btn-sm btn-primary'
                                                            onClick={() => setShowEnvelopeModal(true)}
                                                        >
                                                            <i className='bi bi-envelope me-2'></i>
                                                            Send New Envelope
                                                        </button></> :
                                                    (!boardPerson?.role || boardPerson?.role !== 'Guest') && <button
                                                        type='button'
                                                        className='btn btn-icon btn-light btn-sm btn-primary w-100 px-2'
                                                        onClick={() => navigate('/integrations')}
                                                    >
                                                        Add Integration
                                                    </button>
                                                }
                                            </div>)}
                                    </div>
                                    <div className='card-body px-0 py-1'>
                                        <div className='table-responsive'>
                                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                                <thead>
                                                    <tr className='fw-bolder text-muted'>
                                                        {/* <th className='w-25px'>
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input
                                                                className='form-check-input'
                                                                type='checkbox'
                                                                checked={selectedDocusignAttachments.length === selectedFile.length && selectedFile.length > 0}
                                                                onChange={(e) => handleDocusignSelectAll(e.target.checked)}
                                                            />
                                                        </div>
                                                    </th> */}
                                                        <th className='min-w-200px'>File Name</th>
                                                        <th className='min-w-100px'>Subject</th>
                                                        <th className='min-w-80px'>Sent to</th>
                                                        <th className='min-w-80px'>Status</th>
                                                        <th className='min-w-100px'>Last Updated</th>
                                                        {isIntegrationAvailable && hasAccess && (
                                                            <>
                                                                <th className='w-10px'></th>
                                                                <th className='min-w-100px d-flex justify-content-end pe-5 border-0'>Action</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>
                                                {pageloading && (
                                                    <tbody>
                                                        {Array.from({ length: 3 }, (_, key) => (
                                                            <tr key={key} className='my-2'>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                                <td>
                                                                    <Skeleton count={1} height={25} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                                <tbody>
                                                    {!pageloading &&
                                                        <>
                                                            {envelopes && envelopes?.length > 0 ? envelopes?.map((file: any, index: any) => {
                                                                const lastUpdate = formatDateAndTime(file?.updatedAt);
                                                                return (
                                                                    <tr key={index}>
                                                                        {/* <td>
                                                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input
                                                                        className='form-check-input'
                                                                        type='checkbox'
                                                                        checked={isSelected}
                                                                        onChange={(e) => handleDocusignAttachmentSelection(file, e.target.checked)}
                                                                    />
                                                                </div>
                                                            </td> */}
                                                                        <td>
                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='symbol symbol-45px me-2'>
                                                                                    <FileIcon fileName={file.documentName} showName={file.documentName} />
                                                                                </div>
                                                                                <div className='d-flex justify-content-start flex-column'>
                                                                                    <span className={`${theme === 'dark' ? 'white__text' : 'text-dark'} fw-bold fs-6`}>
                                                                                        {file.documentName?.toLowerCase() || file.showName?.toLowerCase()}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>{file?.subject || '-'}</td>
                                                                        <td className={`${(file?.requesterId === id) ? 'cursor-pointer text-decoration-underline text-primary' : ''}`} onClick={
                                                                            () => {
                                                                                if (file?.requesterId !== id) return;
                                                                                setOpenViewRecepeints(true)
                                                                                setSelectedEnvelope(file);
                                                                            }
                                                                        }>
                                                                            {(file?.requesterId === id) ? file?.signerEmails?.length : '-'}</td>
                                                                        <td>{capitalizeEachWord(file?.status)}</td>
                                                                        <td>{lastUpdate}</td>
                                                                        {isIntegrationAvailable && hasAccess && (<>
                                                                            <td>
                                                                                {file?.id === isDownloading ?
                                                                                    <> <Spinner animation='border' variant='primary' /></>
                                                                                    :
                                                                                    (<span className="cursor-pointer" onClick={() => downloadEnvelopeHandler(file)}>
                                                                                        <i className={`bi bi-download fs-3 ${theme === 'dark' ? 'text-white' : ''}`} ></i>
                                                                                    </span>)

                                                                                }
                                                                            </td>
                                                                            <td className='justify-content-end px-5 d-flex pe-5 border-0'>
                                                                                <Dropdown>
                                                                                    <Dropdown.Toggle size='sm' variant='secondary' id='dropdown-basic'>
                                                                                        <i className='bi bi-three-dots'></i>
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu className={theme === 'dark' ? 'theme__div position-fixed' : 'position-fixed'}>
                                                                                        <Dropdown.Item
                                                                                            className={theme === 'dark' ? 'text-muted' : 'text-dark'}
                                                                                            onClick={() => {
                                                                                                setOpenViewEnvelope(true)
                                                                                                setSelectedEnvelope(file);
                                                                                            }}
                                                                                        >
                                                                                            View Document
                                                                                        </Dropdown.Item>
                                                                                        {((file?.requesterId === id) && !['completed', 'voided', 'deleted', 'timeout'].includes(file?.status)) && (
                                                                                            <Dropdown.Item
                                                                                                className={theme === 'dark' ? 'text-muted' : 'text-dark'}
                                                                                                onClick={() => {
                                                                                                    setShowVoidModal(true);
                                                                                                    setSelectedEnvelope(file);
                                                                                                }}
                                                                                            >
                                                                                                Void Document
                                                                                            </Dropdown.Item>
                                                                                        )}
                                                                                        {((file?.requesterId === id) && ['sent', 'delivered', 'declined'].includes(file?.status)) && (
                                                                                            <Dropdown.Item
                                                                                                className='text-primary'
                                                                                                onClick={() => {
                                                                                                    setShowResendModal(true)
                                                                                                    setSelectedEnvelope(file)
                                                                                                }}
                                                                                            >
                                                                                                Resend Document
                                                                                            </Dropdown.Item>
                                                                                        )}
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </>)}
                                                                    </tr>
                                                                );
                                                            }) :
                                                                <tr>
                                                                    <td colSpan={5} className='text-center py-5'>
                                                                        <div className='d-flex flex-column align-items-center'>
                                                                            <i className='bi bi-inbox fs-2x text-muted mb-3'></i>
                                                                            <span className={`${theme === 'dark' ? 'text-muted' : 'text-muted'} fs-6`}>
                                                                                {(isIntegrationAvailable && hasAccess) ?
                                                                                    'No attachments added yet. Click "Send Envelope" to add documents.' :
                                                                                    'No DocuSign integration found. Please add the integration to send envelopes.'}
                                                                            </span>
                                                                            {(isIntegrationAvailable && hasAccess) ?
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn btn-sm btn-primary mt-3'
                                                                                    onClick={() => setShowEnvelopeModal(true)}
                                                                                >
                                                                                    <i className='bi bi-plus-circle me-2'></i>
                                                                                    Send Envelope
                                                                                </button> :
                                                                                (!boardPerson?.role || boardPerson?.role !== 'Guest') && <button
                                                                                    type='button'
                                                                                    className='btn btn-icon btn-light btn-sm btn-primary w-200px px-2'
                                                                                    onClick={() => navigate('/integrations')}
                                                                                >
                                                                                    Add Integration
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </>}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            </div>
            {!expandedField && <div className='col-md-12 col-lg-4 col-sm-12 border px-4 py-3'>
                <div className='col-12 my-2'>
                    <label className={`${theme === 'dark' ? 'white__text' : 'text-dark'} form-label fs-6 fw-bolder `}>Board</label>
                    <SelectBoard
                        role={boardPerson?.role}
                        boards={allBoards}
                        setBoardId={setBoardId}
                        boardId={boardId}
                        boardName={boardName}
                    />
                </div>
                <div className='col-12 my-2'>
                    <label className={`${theme === 'dark' ? 'white__text' : 'text-dark'} form-label fs-6 fw-bolder `}>Status</label>
                    <SelectStatus role={boardPerson?.role} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
                </div>
                <div className='col-12 my-2'>
                    <h6 className={theme === 'dark' ? 'white__text' : ''}>Members on this page</h6>
                    <div onClick={() => setOpenInviteModal(true)} style={{ color: '#009ef7', cursor: 'pointer' }}>+Invite to this page</div>

                    {isUserAssignLoading ? (
                        <Skeleton count={1} height={97} />
                    ) : (
                        <AssignTo
                            role={boardPerson?.role}
                            page={true}
                            options={options}
                            setSelected={setSelected}
                            selected={removeDuplication(selected)}
                        />
                    )}
                </div>
                <div className='col-12 my-3'>
                    <h6 className={theme === 'dark' ? 'white__text' : ''}>Tags</h6>
                    {loading ? (
                        <Skeleton count={1} height={40} />
                    ) : (
                        <SelectTags role={boardPerson?.role} tags={tags} transformedTags={transformedTags} setSelectedTags={setSelectedTags} selectedTags={selectedTags} boardId={boardId} />
                    )}

                </div>
                <div className='col-12 my-3'>
                    <h6 className={theme === 'dark' ? 'white__text' : ''}>Date last updated</h6>
                    <input
                        type='text'
                        disabled
                        className='form-control w-100'
                        placeholder='dd-mm-yyy'
                        style={inputStyle}
                        value={formattedDate}


                    />
                </div>
            </div>}

            {/* Send Envelope Modal */}
            <SendEnvelopeModal
                showModal={showEnvelopeModal}
                closeModal={closeEnvelopeModal}
                // assignees={removeDuplication(selected)}
                pageId={pageId}
                refetchPageEnvelopes={getPageHandler}
            />
            {openViewEnvelope && (
                <ViewEnvelopeModal showModal={openViewEnvelope} closeModal={() => {
                    setOpenViewEnvelope(false)
                }}
                    envelopeId={selectedEnvelope?.envelopeId}
                    isSender={selectedEnvelope?.requesterId === id}
                    status={selectedEnvelope?.status}
                />
            )}
            {openViewRecepeints && (
                <ViewEnvelopeRecepient showModal={openViewRecepeints} closeModal={() => {
                    setOpenViewRecepeints(false)
                    setSelectedEnvelope(null)
                }}
                    envelope={selectedEnvelope}
                />
            )}
            {showResendModal && (
                <ResendEnvelopeModal showModal={showResendModal} closeModal={() => {
                    setShowResendModal(false)
                    setSelectedEnvelope(null)
                }}
                    onResendHandler={resendEnvelopeHandler}
                    envelope={selectedEnvelope}
                    message={successMessage}
                    errorMessage={errorMessage}
                    loading={isLoading}
                />
            )}
            {showVoidModal && (
                <VoidEnvelopeModal showModal={showVoidModal} closeModal={() => {
                    setShowVoidModal(false)
                    setSelectedEnvelope(null)
                }}
                    onVoidHandler={voidEnvelopeHandler}
                    envelope={selectedEnvelope}
                    errorMessage={errorMessage}
                    message={successMessage}
                    loading={isLoading}
                />
            )}
        </form>
    )
}

export default EditPageForm